export default __webpack_public_path__ + "static/media/e4.7f539e33.webp";